import React, { useEffect, useState } from "react";
import Header from "components/Header/Header.js";
import Button from "components/CustomButtons/Button.js";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { useHistory, useLocation } from "react-router-dom";

const useStyles = makeStyles(headersStyle);

export default function KisetsuNavbar({ color = "transparent" }) {
  const classes = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:600px)");

  const isContactTransparent = location.pathname === "/contact-us" && !scrolled;
  const linkStyle = isContactTransparent ? { color: "black" } : {};

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 200);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Header
      id="kisetsu-navbar"
      fixed
      color={color}
      brand={
        <img
          src={require("assets/img/us/kisetsu-lg.png")}
          alt="Kisetsu Logo"
          style={{
            height: isMobile
              ? scrolled
                ? "70px"
                : "95px"
              : scrolled
              ? "100px"
              : "180px",
            transform: scrolled
              ? "translateY(0)"
              : isMobile
              ? "translateY(0)"
              : "translateY(30px)",
            transition: "all 0.3s ease",
            filter:
              location.pathname === "/contact-us"
                ? "none"
                : color !== "transparent" || scrolled
                ? "none"
                : "brightness(0) invert(1)",
            marginBottom: scrolled ? "0" : "-20px",
          }}
        />
      }
      links={
        <div className={classes.collapse}>
          <List className={classes.list + " " + classes.mlAuto}>
            <ListItem className={classes.listItem}>
              <Button
                href="/"
                className={classes.navLink}
                color="transparent"
                style={linkStyle}
              >
                ANASAYFA
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                onClick={() => history.push("/products")}
                className={classes.navLink}
                color="transparent"
                style={linkStyle}
              >
                MAĞAZA
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                onClick={() => history.push("/about-us")}
                className={classes.navLink}
                color="transparent"
                style={linkStyle}
              >
                HAKKINDA
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                href="/blog-posts"
                className={classes.navLink}
                color="transparent"
                style={linkStyle}
              >
                BLOG
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                onClick={() => history.push("/contact-us")}
                className={classes.navLink}
                color="transparent"
                style={linkStyle}
              >
                İLETİŞİM
              </Button>
            </ListItem>
          </List>
          <List className={classes.list + " " + classes.mlAuto}>
            <ListItem className={classes.listItem}>
              <Button
                color="transparent"
                href="https://instagram.com/mykisetsu/"
                target="_blank"
                className={classes.navLink + " " + classes.navLinkJustIcon}
                style={linkStyle}
              >
                <i className="fab fa-instagram" />
              </Button>
            </ListItem>
          </List>
        </div>
      }
      changeColorOnScroll={{
        height: 200,
        color: "white",
      }}
    />
  );
}
